import React, {Component} from 'react';
import Action from 'components/organisms/dominator-stacking/actions';
import {connect} from 'react-redux';

class RemoveStackItem extends Component {
    onClick(itemId) {
        this.props.dispatch(Action.do('removeItemOfDominatorStacking', itemId));
    }

    render() {
        const {itemId} = this.props;
        return <span onClick={() => ::this.onClick(itemId)} className="tag-remove"></span>;
    }
}

export default connect(() => ({}))(RemoveStackItem);
